var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "m-neg-horizontal-1" }, [
    _vm.routes
      ? _c(
          "nav",
          {
            attrs: {
              role: "navigation",
              "aria-label": _vm.$t("Accessibility.FormTabs")
            }
          },
          [
            _c("div", { staticClass: "d-block d-md-none mobile" }, [
              _c(
                "div",
                { staticClass: "nav nav-tabs justify-content-between" },
                [
                  _c(
                    "div",
                    { staticClass: "pt-1 pl-2 pr-0 left" },
                    [
                      _vm.previousRoute
                        ? _c(
                            "router-link",
                            {
                              attrs: {
                                tag: "li",
                                to: { name: _vm.previousRoute.name }
                              }
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-sm btn-nav",
                                  attrs: {
                                    type: "button",
                                    tabindex: "0",
                                    "aria-current": false
                                  }
                                },
                                [
                                  _c(
                                    "i",
                                    { staticClass: "fas fa-chevron-left" },
                                    [
                                      _c("span", { staticClass: "sr-only" }, [
                                        _vm._v(_vm._s(_vm.$t("Btn_Back")))
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-item",
                          attrs: { tag: "li", to: { name: _vm.$route.name } }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "nav-text",
                              staticStyle: { "font-size": "16px" },
                              attrs: { href: "#", "aria-current": "step" }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.activeIndex + 1) +
                                  ". " +
                                  _vm._s(_vm.$t(_vm.$route.meta.title))
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.showValidationError(_vm.$route.name)
                            ? _c(
                                "i",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip.top.center",
                                      value: {
                                        content: _vm.$t("Validation.hasError"),
                                        classes: "error"
                                      },
                                      expression:
                                        "{ content: $t('Validation.hasError'), classes: 'error' }",
                                      modifiers: { top: true, center: true }
                                    }
                                  ],
                                  staticClass:
                                    "fas fa-exclamation-triangle fa-lg icon white",
                                  attrs: { tabindex: "0" }
                                },
                                [
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("Validation.hasError"))
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pt-1 pr-2 pl-0 right" },
                    [
                      _vm.nextRoute
                        ? _c(
                            "router-link",
                            {
                              attrs: {
                                tag: "li",
                                to: { name: _vm.nextRoute.name }
                              }
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-sm btn-nav",
                                  attrs: {
                                    type: "button",
                                    tabindex: "0",
                                    "aria-current": false
                                  }
                                },
                                [
                                  _c(
                                    "i",
                                    { staticClass: "fas fa-chevron-right" },
                                    [
                                      _c("span", { staticClass: "sr-only" }, [
                                        _vm._v(_vm._s(_vm.$t("Btn_Next")))
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-none d-md-block" }, [
              _c(
                "ul",
                {
                  class: [
                    _vm.condensed ? "condensed" : "",
                    "nav nav-tabs p-horizontal-2"
                  ]
                },
                _vm._l(_vm.routes, function(route, index) {
                  return _c(
                    "router-link",
                    {
                      key: route.name,
                      staticClass: "nav-item",
                      attrs: { tag: "li", to: { name: route.name } }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "nav-text",
                          attrs: {
                            href: "#",
                            "aria-current": _vm.isActiveRoute(route)
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(index + 1) +
                              ". " +
                              _vm._s(_vm.$t(route.meta.title))
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showValidationError(route.name)
                        ? _c(
                            "i",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.top.center",
                                  value: {
                                    content: _vm.$t("Validation.hasError"),
                                    classes: "error"
                                  },
                                  expression:
                                    "{ content: $t('Validation.hasError'), classes: 'error' }",
                                  modifiers: { top: true, center: true }
                                }
                              ],
                              staticClass:
                                "fas fa-exclamation-triangle fa-lg icon white",
                              attrs: { tabindex: "0" }
                            },
                            [
                              _c("span", { staticClass: "sr-only" }, [
                                _vm._v(_vm._s(_vm.$t("Validation.hasError")))
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                }),
                1
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }